import React, { useState, useEffect } from 'react'
import CreatableSelect from 'react-select/creatable'

import { useTranslation } from 'react-i18next'
import BasicModal from '../Dialog'
import { Button, Chip } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'

export default function AddTags(props: any) {
  const { t } = useTranslation('translation')
  const [tags, setTags] = useState([])
  const [selectedTags, setSelectedTags] = useState([])
  useEffect(() => {
    if (!props.show) {
      return
    }
    setTags([...props.selectedTags])
    setSelectedTags([...props.selectedTags])
  }, [props.selectedTags, props.show])

  const handleChange = (newValue: any) => {
    setTags([...newValue])
    setSelectedTags([...newValue])
  }

  const removeTagsHandler = (value: any) => {
    const oldTags = [...tags]
    const hasTagPresent = oldTags.findIndex(
      tag => tag.value.toLowerCase() === value.toLowerCase(),
    )
    if (hasTagPresent >= 0) {
      oldTags.splice(hasTagPresent, 1)
      setTags([...oldTags])
      setSelectedTags([...oldTags])
    }
  }

  return (
    <BasicModal
      open={props.show}
      onClose={props.onHide}
      title={t('Add Keywords')}
      sx={{ p: 2 }}
    >
      <div className="knowledge-tags d-flex flex-wrap align-items-center">
        {tags.length > 0 &&
          tags.map((value, index) => {
            return (
              <Chip
                key={value + '_' + index}
                label={value.label}
                onDelete={() => removeTagsHandler(value.value)}
                deleteIcon={<CloseIcon fontSize="small" />}
                sx={{
                  '.MuiChip-deleteIcon': {
                    color: 'white',
                  },
                }}
              />
            )
          })}
      </div>
      <div className="changepurpose-select-tag">
        <CreatableSelect
          isMulti
          // defaultMenuIsOpen
          controlShouldRenderValue={false}
          isClearable={false}
          className="add-tag-select"
          classNamePrefix="add-tags"
          onChange={handleChange}
          // onInputChange={handleInputChange}
          defaultValue={selectedTags}
          value={selectedTags}
          options={[...tags]}
          placeholder={t('Type tag name')}
          components={{
            DropdownIndicator: () => null,
            IndicatorSeparator: () => null,
          }}
        />
      </div>
      <div className="tw-flex tw-justify-end tw-gap-2 tw-mt-4">
        <Button
          variant="contained"
          onClick={e => props.confirmhandler(e, tags)}
          disabled={tags.length === 0}
        >
          {t('Done')}
        </Button>
        <Button variant="outlined" onClick={props.onHide}>
          {t('Cancel')}
        </Button>
      </div>
    </BasicModal>
  )
}
